import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Medication.module.css';
import { DBTextArea } from '_components';
import {PatientCareCenterNoteWpSubjectiveHistory} from 'PatientCareCenter/Note/WorkProgram';
import {PatientCareCenterNoteWpSubjectivePrevTher} from 'PatientCareCenter/Note/WorkProgram';
import {PatientCareCenterNoteWpSubjectiveCognition} from 'PatientCareCenter/Note/WorkProgram';
import {PatientCareCenterNoteWpSubjectiveMedication} from 'PatientCareCenter/Note/WorkProgram';
import {PatientCareCenterNoteWpSubjectiveWorkComp} from 'PatientCareCenter/Note/WorkProgram';
import {PatientCareCenterNoteWpSubjectivePain} from 'PatientCareCenter/Note/WorkProgram';
import {PatientCareCenterNoteWpSubjectiveParticipation} from 'PatientCareCenter/Note/WorkProgram';
class PatientCareCenterNoteWpSubjective extends React.Component {
    render() {
        return (
            <PatientCareCenterNoteSection id='subjective' name='Subjective' refProp={this.props.refProp} level={5}>
           {this.props.noteType !== 1 && this.props.subKeyValues.length > 0 && (
                <div>
                    <div className={this.props.isSubDetailsNotNull ? styles.sub_req : styles.sub_notReq}>Subjective:</div>
                    {this.props.subKeyValues.map((id, index) => {
                    return (
                        <div className={styles.row} key={id}>
                        <DBTextArea
                            noteId={this.props.noteId}
                            entity="PTSUBJECTIVE"
                            entityKeyColumn="SUNO"
                            entityKeyValue={id.SUNO}
                            field="SUDETAILS"
                            className={styles.supplment_textarea}
                        />
                        </div>
                    );
                    })} 
                </div>
                )}

                {this.props.noteType === 1 && 
                <span>
                    <PatientCareCenterNoteWpSubjectiveHistory />
                    <PatientCareCenterNoteWpSubjectivePrevTher />
                    <PatientCareCenterNoteWpSubjectiveCognition />
                    <PatientCareCenterNoteWpSubjectiveMedication />
                </span>
                } 
                {this.props.noteType !== 1 && 
                    <span>  
                        <PatientCareCenterNoteWpSubjectiveParticipation />
                    </span>
                }
                    <PatientCareCenterNoteWpSubjectivePain />
                    <PatientCareCenterNoteWpSubjectiveWorkComp />
            </PatientCareCenterNoteSection>
        );
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);

    let entries = Object.keys(state.entities.notes.PTSUBJECTIVE)
        .filter(key => state.entities.notes.PTSUBJECTIVE[key].SUNTNO === pk)
        .sort((a, b) => state.entities.notes.PTSUBJECTIVE[a].SUNO - state.entities.notes.PTSUBJECTIVE[b].SUNO)
        .map(key => state.entities.notes.PTSUBJECTIVE[key].SUNO);

    let isSubDetailsNotNull = Object.keys(state.entities.notes.PTSUBJECTIVE)
                .filter(key => {
                    return (state.entities.notes.PTSUBJECTIVE[key].SUNTNO === pk &&
                        (
                            state.entities.notes.PTSUBJECTIVE[key]?.SUDETAILS === null
                        )
                    )
        }).length !== 0;

    let subKeyValues = [];

    if (entries.length !== 0) {
        entries.forEach(id => {
            subKeyValues.push(state.entities.notes.PTSUBJECTIVE[id]);
        });
    }

    return {
        pk,
        isSubDetailsNotNull,
        subKeyValues,
        noteId,
        noteType,
        entries,
    };
}

const connectedPatientCareCenterNoteWpSubjective = connect(mapStateToProps)(PatientCareCenterNoteWpSubjective);
export { connectedPatientCareCenterNoteWpSubjective as PatientCareCenterNoteWpSubjective };

